<template>
	<div class="share-buttons">
		<a class="share" @click="clickFacebook"><img :src="social.facebook_button_image"  /></a>
		<a class="share" @click="clickTwitter"><img :src="social.twitter_button_image"  /></a>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'ComputerAlert',
	props: ['isOpen'],
	computed: {
		...mapState({ // get data from wordpress Game Config page
			email_data: state => state.config.data.email.find(email => email.email_type === "Game Over"),
			game_config: state => state.config.data.game_config,
			social: state => state.config.data.social,
		}),
		encodedUrl() {
			return encodeURIComponent(window.location.origin);
		},
		getAdjective() {
			return this.$store.state.adjective;
		},
		getPlayerName() {
			return this.$store.state.playerName;
		},
		formattedMoney() {
			return this.formatMoney(this.$store.state.totalMoney);
		},
	},
	methods: {
		formatMoney(amt) {
			return amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		shareText(platform) {
			if (platform === 'fb') {
				return this.social.facebook_custom.description.replace("{{Adjective}}", this.getAdjective).replace("{{Name}}", this.getPlayerName).replace("{{playerScore}}", this.formattedMoney);
			}
			return this.social.twitter_custom.description.replace("{{Adjective}}", this.getAdjective).replace("{{Name}}", this.getPlayerName).replace("{{playerScore}}", this.formattedMoney);
		},
		clickFacebook(e) {
			e.preventDefault();
			window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.encodedUrl}&quote=${encodeURIComponent(this.shareText('fb'))}`, 'target window', `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=650,height=300`);
			return false;
		},
		clickTwitter(e) {
			e.preventDefault();
			window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareText('tw'))}&url=${this.encodedUrl}`, 'target window', `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=650,height=300`);
			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
	.share-buttons{
		display: inline-flex;
		vertical-align: middle;
		a{
			cursor: pointer;
			text-decoration: none !important;
			border: none !important;
			width: 50px;
			@include breakpoint(xsm){
				width: 35px;
			}
			&:hover{
				text-decoration: none !important;
				border: none !important;
				transform: scale(1.1);
			}
			img{
				width: 100%;
				height: auto;
			}
		}
	}
	.share:last-of-type{
		margin: 0 15px;
		@include breakpoint(xsm){
			margin: 0 25px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/ShareButtons.vue